import React from "react";
import styled from "styled-components";

import * as u from "../utils";
import * as gtag from "../utils/gtag";
import * as T from "./Typography";
import Button from "../components/Button";
import TickInput from "./TickInput";

export default function EventCollection(props) {
  const [listLength, setListLength] = React.useState(
    props.initialListSize || 8
  );
  const slicedItems = props.children.slice(0, listLength);
  const canShowMore = props.children.length >= listLength;

  return (
    <S.Container data-cy={props.datacy}>
      <S.HeadingContainer>
        {props.heading && <T.H3>{props.heading}</T.H3>}
        {props.heading === "Upcoming events" && (
          <S.Filters>
            {props.canFilter && (
              <TickInput
                name="filter"
                isTrue={props.showAccessEvents}
                onChange={onFilter}
              >
                <T.CM>Only show events available with my membership</T.CM>
              </TickInput>
            )}
          </S.Filters>
        )}
      </S.HeadingContainer>
      {slicedItems.length > 0 && (
        <S.EventsWrapper data-cy={props.datacy}>{slicedItems}</S.EventsWrapper>
      )}
      {canShowMore && (
        <S.Button
          onClick={showMore}
          data-cy={props.datacy + "ShowMore"}
          text="Show more"
          isSecondary
        />
      )}
    </S.Container>
  );

  function onFilter() {
    gtag.event({
      name: gtag.GA_EVENT.EVENT_ENGAGEMENT,
      category: "Events",
      label: "Toggle checkbox",
      value: `${props.showAccessEvents ? "Hide" : "Show"} available events`,
    });

    props.setShowAccessEvents(!props.showAccessEvents);
  }

  function showMore() {
    const newListLength = listLength + 8;
    setListLength(newListLength);
    gtag.event({
      name: gtag.GA_EVENT.EVENT_ENGAGEMENT,
      category: "Events",
      label: `Visible events in ${props.heading}`,
      value: newListLength,
    });
  }
}

const S = {};

S.Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 40px;
`;

S.Filters = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  @media (min-width: 750px) {
    flex-direction: row;
    > * {
      padding-left: 20px;
    }
  }
`;

S.EventsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  margin-bottom: 20px;
  column-gap: 30px;
  row-gap: 40px;

  @media ${u.device.mobile} {
    column-gap: 30px;
    row-gap: 40px;

    grid-template-columns: repeat(2, 1fr);
  }

  @media ${u.device.tablet} {
    column-gap: 30px;
    row-gap: 40px;

    grid-template-columns: repeat(3, 1fr);
  }

  @media ${u.device.desktop} {
    column-gap: 30px;
    row-gap: 40px;
    grid-template-columns: repeat(4, 1fr);
  }
`;

S.Button = styled(Button)`
  margin: 0 auto;
`;

S.HeadingContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (min-width: 750px) {
    flex-direction: row;
  }
`;
